import { Component, OnInit } from '@angular/core';
import * as titleActions from './../shared/state/actions/title.action';
import * as fromShared from "./../shared/state/reducers";
import { Store } from '@ngrx/store';
import { AppConfigConstants } from '../core/config/app.config.constants';
import { AppConfig } from '../core/config/app.config';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ats-applicant-home',
  styleUrls: ['./applicant-home.component.scss'],
  templateUrl: './applicant-home.component.html',
})

export class ApplicantHomeComponent implements OnInit {

  constructor(private sharedStore: Store<fromShared.State>, private _sanitizer: DomSanitizer) { }

  pageTitle = "Home";
  //safeUrl;
  ngOnInit() {
    this.sharedStore.dispatch(titleActions.SetTitle({ title: this.pageTitle }));
    //this.safeUrl = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/wTcNtgA6gHs');
  }

  getVideoURL(name: string, extension: string) {
    let url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.ADMINISTRATION_URL_SEGMENT]).concat(`/get-ats-document/${name}/${extension}`);
    return url;
  }

}
